import apiService from './apiService'

/**
 * MongoDB Explorer Service
 * Handles API calls for the MongoDB admin explorer feature.
 * Uses centralized apiService for authentication and base URL handling.
 */
export default {
  /**
   * Get a list of MongoDB collection names.
   * @returns {Promise} Resolves with array of collection name strings
   */
  getCollections: function() {
    return apiService.get('api/mongo/collections')
  },

  /**
   * Fetch a single MongoDB document by collection name and _id.
   * @param {string} collection - Collection name (e.g. "racers", "locations")
   * @param {string} id - The document _id value to look up
   * @returns {Promise} Resolves with the document or null
   */
  getDocument: function(collection, id) {
    return apiService.get('api/mongo/collection/' + collection + '/document/' + encodeURIComponent(id))
  }
}



// WEBPACK FOOTER //
// ./src/services/mongoExplorer.js